import { render, staticRenderFns } from "./modalDescargarXml.vue?vue&type=template&id=b2a835de&"
import script from "./modalDescargarXml.vue?vue&type=script&lang=js&"
export * from "./modalDescargarXml.vue?vue&type=script&lang=js&"
import style0 from "./modalDescargarXml.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a835de')) {
      api.createRecord('b2a835de', component.options)
    } else {
      api.reload('b2a835de', component.options)
    }
    module.hot.accept("./modalDescargarXml.vue?vue&type=template&id=b2a835de&", function () {
      api.rerender('b2a835de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalDescargarXml.vue"
export default component.exports